hrd.HtmlDialogFactory = hrd.HtmlAbstractFactory.extend({
	init: function(options){
		var defaults = {
			impl: 'hrd.HtmlDialogFactory',
			xlate: true
		};
		this._super($.extend(true, {}, defaults, options));
		var $container = $('<div class="ui-helper-hidden"></div>');
		this.addDataAttribute($container, 'title',  options);
		this.addDataAttribute($container, 'name',  options);
		this.addDataAttribute($container, 'width',  options);
		this.addDataAttribute($container, 'height', options);
		this.addDataAttribute($container, 'popup',  options);
		this.addDataAttribute($container, 'events',  options);
		if(options.cssClass != undefined){
			$container.addClass(options.cssClass);
		}
		this.$container = $container;
	},
	getFormFactory: function(){
		if(this.formFactory == undefined){
			this.formFactory = new hrd.HtmlFormFactory(this.$container, {xlate: this.settings.xlate});
		}
		return this.formFactory;
	},
	useHTMLSnippet: function(html){
		this.$container.append(html);
	},
	create: function(useAsDialogImplementation){
		var $htmlDialog = this.$container.detach();
		this.$dialog = $htmlDialog.appendTo('body');
		this.dialogId = '#' + this.$dialog.uniqueId().attr('id');
		if(useAsDialogImplementation === true){
			this.$dialog.data('useAsDialogImplementation', true);
		}
		return this.$dialog;
	},
	discard: function(){
		this.$dialog.remove();
	},
	show: function(inputData, options, formOptions){
		options = options || {};
		var deferred = $.Deferred();
		hrd.form.showFormDialog(this.dialogId, inputData, options, formOptions)
			.then((obj, dialogOpt) => deferred.resolve(obj, dialogOpt))
			.progress((obj, dialogOpt) => deferred.notify(obj, dialogOpt))
			.fail(dialogOpt => deferred.reject(dialogOpt))
			.always(() => {
				if(!options.doNotCloseOnOk){
					$.timeout(0).then(() => this.discard());
				}
			});
		return deferred.promise();
	},
	open: function(inputData, options, formOptions){
		this.create();
		return this.show(inputData, options, formOptions);
	},
	close: function(){
		this.$dialog.dialog('close');
	},
	startWaiting: function(){
		this.$dialog.waiting();
	},
	endWaiting: function(){
		this.$dialog.waiting('done');
	}
});